import React from 'react';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import { CommonActions } from '../../../Reducer/CommonReducer';
import BadgeItem from '../../../Components/Ui/BadgeItem';
import { useNavigate } from 'react-router-dom';

export default function ListItem({ item, showBorder = true }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <article
      onClick={() => {
        dispatch(CommonActions.increaseStep());
        navigate(`/M_Notice/detail/${item.chaebunNo}`);
      }}
      className="shadow-soft cursor-pointer rounded-2xl bg-white p-5 transition-transform active:scale-[0.99]"
    >
      {/* 배지 */}
      <div className="mb-1 flex gap-2">
        {item?.noticeYn === 'Y' && <BadgeItem type="중요" label="중요" />}
        <BadgeItem type={item?.gubunNm} label={item?.gubunNm} />
      </div>

      {/* 제목 */}
      <p className="mb-2 line-clamp-2 text-base leading-snug font-bold text-slate-800">
        {item.title}
      </p>

      {/* 메타 정보 */}
      <div className="flex items-center text-xs font-medium text-slate-400">
        <span className="whitespace-nowrap">
          {item.name} | {dayjs(item.updateDate).format('YYYY-MM-DD')}
        </span>
      </div>
    </article>
  );
}
